module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        Past Cost of DIY/Services — " + _vm._s(_vm.currencyFormat(_vm.value)) + "\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        This head of loss is calculated applying (i) an average annual figure from claims of a similar type, and (ii) assuming loss from date of onset of symptoms to death. Where there is insufficient data within the tool to derive an average annual loss then this is assessed at £1,500.\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-af6213f2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/reserving/day-one/lost/accordian-content/PastServicesModal.vue
// module id = 1791
// module chunks = 0